export const okrDetailConstants = {
    SET_MY_OKR_STATUS: 'SET_MY_OKR_STATUS',
    GET_GOAL_DETAILS_SUCCESS : 'GET_GOAL_DETAILS_SUCCESS',
    GET_GOAL_DETAILS_FAIL: 'GET_GOAL_DETAILS_FAIL',
    UPDATE_INITIAL_PROPS: 'UPDATE_INITIAL_PROPS',
    PROGRESS_TYPE_BAR: 'BAR',
    PROGRESS_TYPE_CIRCLE: 'CIRCLE',
    FILTER_OVER_DUE_KR: 'FILTER_OVER_DUE_KR',
    FILTERED_DATA: 'FILTERED_DATA',
    GET_MY_GOALS_FILTERED: 'GET_MY_GOALS_FILTERED',
    UPDATE_GOAL_DETAILS_SUCCESS: 'UPDATE_GOAL_DETAILS_SUCCESS',
    GET_KR_SOURCE_POPUP_DATA: 'GET_KR_SOURCE_POPUP_DATA',
    UPDATE_WORKSTREAM_PROPS: 'UPDATE_WORKSTREAM_PROPS',
    GET_FULL_ALIGN_DATA: 'GET_FULL_ALIGN_DATA',
    GET_TEAMS_OKR_SUCCESS: 'GET_TEAMS_OKR_SUCCESS',
    ADD_NEW_KR :'ADD_NEW_KR',
    DELETE_KR: 'DELETE_KR',
    SET_KEY_RESULTS_STATUS: 'SET_KEY_RESULTS_STATUS',
    
    PAGE_TYPE_OKR_I_OWN:'PAGE_TYPE_OKR_I_OWN',
    PAGE_TYPE_KR_I_UPDATE: 'PAGE_TYPE_KR_I_UPDATE',
    PAGE_TYPE_MY_MANAGER_OKR: 'PAGE_TYPE_MY_MANAGER_OKR',
    PAGE_TYPE_MY_TEAM_OKR:'PAGE_TYPE_MY_TEAM_OKR',
    PAGE_TYPE_TEAM_TAB_OKR:'PAGE_TYPE_TEAM_TAB_OKR',
    PAGE_TYPE_MY_DIRECT_OKR:'PAGE_TYPE_MY_DIRECT_OKR',
    PAGE_TYPE_MY_DIRECT_KR:'PAGE_TYPE_MY_DIRECT_KR',
    PAGE_TYPE_WS_TAB_OKR:'PAGE_TYPE_WS_TAB_OKR',
    PAGE_TYPE_JUMP_TO_OKR:'PAGE_TYPE_JUMP_TO_OKR',
    PAGE_TYPE_PERSON_KR_SEARCH:'PAGE_TYPE_PERSON_KR_SEARCH',
    
    GET_KRS_I_UPDATE_SUCCESS: 'GET_KRS_I_UPDATE_SUCCESS',
    RESET_LOADER: 'RESET_LOADER',
    UPDATE_PERSON_SEARCH_RESULT: 'UPDATE_PERSON_SEARCH_RESULT',
    OKR_ERROR_HANDLING: 'OKR_ERROR_HANDLING',
    UPDATE_INITIAL_TEAMS_DATA: 'UPDATE_INITIAL_TEAMS_DATA',
    HANDLE_OVERDUE_KR: 'HANDLE_OVERDUE_KR',
    SYNC_OVERDUE_STATUS: 'SYNC_OVERDUE_STATUS',
    UPDATE_OVERDUE_KR_SUCCESS: 'UPDATE_OVERDUE_KR_SUCCESS',
    GET_MY_MANAGER_OKR_SUCCESS: 'GET_MY_MANAGER_OKR_SUCCESS',
    GET_MY_TEAMS_OKR_SUCCESS: 'GET_MY_TEAMS_OKR_SUCCESS',
    RESET_GOAL_DATA: 'RESET_GOAL_DATA',
    UPDATE_KR_REACTED_EMOJI: 'UPDATE_KR_REACTED_EMOJI',
    UPDATE_SHORT_CUT_BAR_SUCCESS: 'UPDATE_SHORT_CUT_BAR_SUCCESS',
    GET_DIRECT_DOTTED_OKRS_SUCCESS: 'GET_DIRECT_DOTTED_OKRS_SUCCESS',
    UPDATE_COMMENT_COUNT: 'UPDATE_COMMENT_COUNT',
    ADD_NEW_GOAL_TO_TEAM: 'ADD_NEW_GOAL_TO_TEAM',
    UPDATE_DIRECT_DOTTED_GOAL: 'UPDATE_DIRECT_DOTTED_GOAL',
    GET_SINGLE_KR_DETAILS: 'GET_SINGLE_KR_DETAILS',
    PERSON_DUE_KEY_RESULTS: 'PERSON_DUE_KEY_RESULTS',
    UPDATE_SHOW_HIDE_METRIC: 'UPDATE_SHOW_HIDE_METRIC',
    RESET_FILTER_COUNT: 'RESET_FILTER_COUNT',
    RESET_FILTER_COUNT_ONCLOSE: 'RESET_FILTER_COUNT_ONCLOSE',
    OVERDUE_KEY_RESULTS_TEAM: 'OVERDUE_KEY_RESULTS_TEAM',
    DIRECT_DOTTED_OKR_DELETE_SUCCESS: 'DIRECT_DOTTED_OKR_DELETE_SUCCESS',
    GET_DIRECT_DOTTED_KRS_SUCCESS: 'GET_DIRECT_DOTTED_KRS_SUCCESS',
    UPDATE_DIRECT_DOTTED_KR: 'UPDATE_DIRECT_DOTTED_KR',
    DELETE_SINGLE_KR: 'DELETE_SINGLE_KR',
    DELETE_DIRECT_DOTTED_KR: 'DELETE_DIRECT_DOTTED_KR',
    EXCLUDE_KR_FROM_LIST: 'EXCLUDE_KR_FROM_LIST',
    REMOVE_CREATE_CASCADE_CARD: 'REMOVE_CREATE_CASCADE_CARD',
    UPDATE_CASCADE_KR_LIST: 'UPDATE_CASCADE_KR_LIST',
    RESET_HANDLE_OVERDUE_KR: 'RESET_HANDLE_OVERDUE_KR',
    DELETE_CASCADE_KR_FROM_LIST: 'DELETE_CASCADE_KR_FROM_LIST',
    SHOW_PAGINATION_LOADER: 'SHOW_PAGINATION_LOADER',
    HIDE_PAGINATION_LOADER: 'HIDE_PAGINATION_LOADER',
    UPDATE_FILTER_PREFERENCES: 'UPDATE_FILTER_PREFERENCES',
    RESET_FULL_ALIGNMENT: 'RESET_FULL_ALIGNMENT',
    RESET_TEAMS_GOAL_DATA: 'RESET_TEAMS_GOAL_DATA',

    GOAL_ACTIVE: 1,
    GOAL_DELETED: 0,
    GOAL_CLOSED: 2,
    GOAL_ALL: 3,  // Both Active and Closed (used by alignment filter API)

    /** goalSummary heatmap scope — mirrors Goal::TEAMS_VIEW, PEOPLE_VIEW, BIZ_GROUPS */
    TEAMS_VIEW: 1,
    PEOPLE_VIEW: 2,
    BIZ_GROUPS: 3,

    /** userTeamType when userTeamid is set — mirrors Goal::USER_SELECTION, TEAM_SELECTION */
    USER_TEAM_TYPE_NONE: 0,
    USER_SELECTION: 1,
    TEAM_SELECTION: 2,

    /** RAG performance filter values — mirrors Goal::PROGRESS_* */
    PROGRESS_GREY: 0,
    PROGRESS_DARK_GREEN: 1,
    PROGRESS_GREEN: 2,
    PROGRESS_AMBER: 3,
    PROGRESS_RED: 4,

    /** team_s / team_p preset when the opposite scope field is inactive (Goal.php default) */
    TEAM_SCOPE_DEFAULT: 4,
    /** team_s / team_p = All teams / All people */
    TEAM_SCOPE_ALL: 0,

    /** exDate: OKR start/end must exactly match the selected period */
    EX_DATE_EXACT_MATCH: 1,
    /** exDate: OKR can span the selected period */
    EX_DATE_SPAN_PERIOD: 0,
    /** exDate: OKR/KR period overlaps the selected range or contains a selected date */
    EX_DATE_ACTIVE_ON: 3,

    /** businessGrpId heatmap uses shared builder */
    USE_SHARED_BUILDER: 1,

    /** categories URL param meaning "no category filter" */
    CATEGORIES_NONE: '0',

    GOAL_TYPE_TEAM: 1,
    GOAL_TYPE_INDIVIDUAL: 2,  // Personal OKR type (matches backend Goal::GOAL_TYPE_USER)

    WB_WORKER_EMAIL: "wb-worker@workboard.com",

    ROLE_MANAGER: 1,
    ROLE_MEMBER: 2,
    ROLE_CO_MANAGER: 3,
    ROLE_TEAM_AMDIN: 4,

    FILTER_PROGRESS_DEFAULT : '4,3,2,1',
    /** All RAG colours including no-status — goalSummary performance default */
    FILTER_PROGRESS_ALL: '4,3,2,1,0',

    /** Sent on previewGoal export from Direct & Dotted OKR tab only */
    HIDE_EMPTY_OKRS_EXPORT: 'hideEmptyOkrs',
    /** GET param for getMyDirectsOKR when objective/KR filters are active */
    HIDE_EMPTY_OKRS_LIST: 'hide_empty_okrs',
    /** POST param for goal/previewGoal Back button (caller page URL) */
    PREVIEW_GOAL_BACK_URL: 'previewBackUrl',
    /**
     * GET param for getMyDirectsOKR: use request filters only (skip saved directAndDottedOkrSummary prefs).
     * Omit on filter reset so the backend may apply stored preferences.
     */
    UI_FILTERS_APPLIED: 'uiFiltersApplied',
}